"use client";
import Image from "next/image";
import { StaticImageData } from "next/image";
import CertificateExampleImg from "@/public/bg-images/example-certificate-verified.webp";
import useProgramRedesignTraffic from "@/monarch/rules/programRedesignTraffic/useProgramRedesignTraffic";

type SideRailImageProps = {
  imageSrc?: string | StaticImageData;
  altDescription?: string;
  width?: number;
  height?: number;
};

export default function SideRailImage({
  imageSrc = CertificateExampleImg,
  altDescription = "Certificate image",
  height = 243,
}: SideRailImageProps) {
  const { sideRailImage } = useProgramRedesignTraffic();
  const { imageUrl: image } = sideRailImage || {};
  const { altDescription: alt } = sideRailImage || {};
  return (
    <div>
      <Image
        src={image ?? imageSrc}
        alt={alt ?? altDescription}
        className={`w-full h-[${height}px] border-2 border-putty-100`}
      />
    </div>
  );
}
